import { Icon } from "@/components/ui/icon";
import { Button } from "@/components/ui/button";

import { carouselNavVariants } from "./carousel-nav.variants";

type CarouselNavProps = {
  swiperId: string;
};

export const CarouselNav = (props: CarouselNavProps) => {
  const { swiperId } = props;

  const styles = carouselNavVariants();

  return (
    <div className={styles.base()}>
      <nav id={`${swiperId}-nav`} className={styles.sliderNav()}>
        <button
          className={styles.button({ className: `prev-carousel-${swiperId}` })}
          type="button"
          aria-label="Previous slide"
        >
          <Icon name="arrow_left" className={styles.icon()} />
        </button>
        <button
          className={styles.button({ className: `next-carousel-${swiperId}` })}
          type="button"
          aria-label="Next slide"
        >
          <Icon name="arrow_right" className={styles.icon()} />
        </button>
      </nav>
    </div>
  );
};
